import { backofficeApiUrls } from 'apis/BackofficeAPI';
import { invalidateStartsWith } from 'hooks/useSWR';
import { PaginatedResult, PaginationOptions } from 'types/api';
import { GreenlistOrganizationDTO } from 'types/organization';
import useResource from 'util/resource/useResource';

export const useBackofficeOrganizations = (
  paginationOptions: PaginationOptions,
  options?: {
    showApproved?: boolean;
    isTestOrganization?: boolean;
    name?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    organizationTypes?: string[];
  },
) =>
  useResource<PaginatedResult<GreenlistOrganizationDTO>>(
    backofficeApiUrls.organizations.list(paginationOptions, options || {}),
  );

export const invalidateBackofficeOrganizations = () => {
  invalidateStartsWith([backofficeApiUrls.organizations.list({}, {})]);
};
